<div fxLayout="row" class="dd-page-not-found" fxLayoutAlign="center center" fxLayoutGap="20">
  <mat-card fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="dd-card-bg">
    <!-- <mat-icon class="dd-toyota-icon">
      <img src="assets/icons/Toyota_logo_no-text.svg" />
    </mat-icon> -->
    <div class="dd-page-not-found-text">
      {{ errorText }} <br><br> {{ directionText }}
    </div>
  </mat-card>
</div>